import { get, post, getTencentFile } from './axios'
import config from './config'
import JSZip from 'jszip'
import store from '@/store/index.js'
import permissionJson from './permission'
const common = {
  // 格式化时间
  formatTime(date, num) {
    if (date) {
      if (typeof (date) === 'number' || typeof (date) === 'object' || typeof (date) === 'string') {
        date = new Date(date)
      }
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      switch (num) {
        case 1:
          return [year, month, day].join('-')
        case 2:
          return [year, month, day].join('/')
        case 3:
          return [year, month, day].join('-') + '' + [hour, minute, second].join(':')
        case 4:
          return [year, month, day].join('.')
        default:
          return [year, month, day].join('-')
      }
    } else {
      return ''
    }
  },
  getQueryString(name, path) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = path.split('?')[1].match(reg)
    if (r != null) return unescape(r[2]); return null
  },
  getUnionId(code, state) {
    const url = '/wechat/open/userInfo?code=' + code + '&state=' + state + '&platform=L'
    return new Promise(function (resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          resolve(res.data.unionId)
        } else {
          reject(res.code)
        }
      })
    })
  },
  // 获取字典数据接口
  getDictionaryItems(code) {
    const url = '/base/dictionaryItem/getDictionaryItemsByCode/' + code
    return new Promise(function (resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
    })
  },
  // 获取字典数据接口
  refreshToken() {
    const refreshToken = window.localStorage.getItem('refreshToken')
    const url = '/authentication/auth/refreshToken'
    const ajaxData = {
      refreshToken: refreshToken,
      client: 'Basic c2VydmljZV9sYXd5ZXI6MTIzNDU2'
    }
    return new Promise(function (resolve, reject) {
      post(url, ajaxData).then(res => {
        if (res) {
          window.localStorage.setItem('token', res.data.accessToken)
          window.localStorage.setItem('account', JSON.stringify(res.data.account))
          resolve(1)
        } else {
          reject(-1)
        }
      })
    })
  },
  // 获取角色
  getRoles() {
    const url = '/base/permissions/lawyer/menu'
    return new Promise(function (resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          const json = {}
          res.data.options = res.data.operations && res.data.operations.map((item) => {
            return item.code
          })
          const roles = res.data.menus || []
          for (let i = 0; i < roles.length; i++) {
            if (!json[roles[i].code]) {
              json[roles[i].code] = roles[i].childList
            }
          }
          // json['case:program:-'] && json['case:program:-'].push({
          //   name: '上诉&再审材料管理',
          //   href: '/carryoutMaterialManage/appealMaterial',
          //   menuLogo: '',
          //   hasChildList: false
          // })
          // json['case:program:-'] && json['case:program:-'].push({
          //   name: '领款&退费材料管理',
          //   href: '/carryoutMaterialManage/refundMaterial',
          //   menuLogo: '',
          //   hasChildList: false
          // })
          // json['case:program:-'] && json['case:program:-'].find(item => item.name === '诉讼方案管理').childList.push({
          //   name: '已驳回',
          //   href: '/actionPlan/reject',
          //   menuLogo: '',
          //   hasChildList: false
          // })
          // json['case:program:-'] && json['case:program:-'].find(item => item.name === '执行材料管理').childList.push({
          //   name: '已驳回',
          //   href: '/carryoutMaterialManage/rejectMaterial',
          //   menuLogo: '',
          //   hasChildList: false
          // })
          //
          // json['case:program:-'] && json['case:program:-'].find(item => item.name === '执行材料管理') && json['case:program:-'].find(item => item.name === '执行材料管理').childList.push({
          //   name: '其它盖章材料申请',
          //   href: '/carryoutMaterialManage/otherMaterial',
          //   menuLogo: '',
          //   hasChildList: false
          // })
          json['case:-'] && json['case:-'].length && json['case:-'].push({
            name: '真相取证工具',
            href: '',
            menuLogo: 'icon-case-01',
            hasChildList: false
          })
          // json['case:program:-'] && json['case:program:-'].push({
          //   name: '执行材料管理',
          //   href: '',
          //   menuLogo: 'icon-ownership-01',
          //   hasChildList: true,
          //   childList: [
          //     {
          //       name: '未提交',
          //       href: '/carryoutMaterialManage/unSubmited',
          //       menuLogo: '',
          //       hasChildList: false
          //     }, {
          //       name: '已提交',
          //       href: '/carryoutMaterialManage/submited',
          //       menuLogo: '',
          //       hasChildList: false
          //     },
          //     {
          //       name: '其它盖章材料申请',
          //       href: '/carryoutMaterialManage/otherMaterial',
          //       menuLogo: '',
          //       hasChildList: false
          //     }
          //   ]
          // })
          if (json['tools:-']) {
            json['tools:-'].push({
              name: '合同助手',
              href: '/tools/fatianshi',
              hasChildList: false,
              menuLogo: 'icon-task-lawyer-04'
            })
            json['tools:-'].push({
              name: '过滤列表',
              href: '/tools/fatianshi/result',
              menuLogo: '',
              hasChildList: false,
              hideMenu: true
            })
            json['tools:-'].push({
              name: '预览',
              href: '/tools/fatianshi/preview',
              menuLogo: '',
              hasChildList: false,
              hideMenu: true
            })
            json['tools:-'].push({
              name: '编辑',
              href: '/tools/fatianshi/edit',
              menuLogo: '',
              hasChildList: false,
              hideMenu: true
            })
          }
          res.data.roles = json
          resolve(res.data)
        } else {
          reject(res)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 截取字符串
  cutString(str, num) {
    if (!str) {
      return
    }
    let returnStr
    if (str.length > num) {
      returnStr = str.substring(0, num) + '...'
    } else {
      returnStr = str
    }
    return returnStr
  },
  tm_status_class(status) {
    if (status.indexOf('无效') !== -1) {
      return 'tmstatus-invalid'
    }
    if (status.indexOf('等待') !== -1) {
      return 'tmstatus-wait'
    }
    if (status.indexOf('异议') !== -1) {
      return 'tmstatus-objection'
    }
    if (status.indexOf('公告') !== -1) {
      return 'tmstatus-review'
    }
    return 'tmstatus-success'
  },
  // 根据对象的某个key排序
  sort_object(property) {
    return function(obj1, obj2) {
      var value1 = obj1[property]
      var value2 = obj2[property]
      return value1 - value2
    }
  },
  /**
   * 将腾讯云文件列表打包成压缩包并下载
   * @param {Array} fileList - 文件列表
   * @returns {Promise} 返回一个Promise对象，当压缩包生成并下载完成时resolve，否则reject
   * @throws {Error} 当fileList参数为空数组、fileList中的元素缺少tencentUrl或fileName字段，或者tencentUrl字段不是腾讯云存储桶中的文件地址时，会抛出错误
   */
  packageTencentFile(fileList) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(fileList) || (Array.isArray(fileList) && fileList.length === 0)) {
        return Promise.reject(new Error('第一个参数必须是非空数组！'))
      } else if (fileList.some(item => !item.tencentUrl || !item.fileName)) {
        return Promise.reject(new Error('数组中每个元素必须包含tencentUrl和fileName字段，且字段值不能为空'))
      } else if (fileList.some(item => !/^(https?:\/\/dev-public-1251740668\.cos\.ap-guangzhou\.myqcloud\.com)/.test(item.tencentUrl) && !/^(https?:\/\/pro-public-1251740668\.cos\.ap-guangzhou\.myqcloud\.com)/.test(item.tencentUrl))) {
        return Promise.reject(new Error('tencentUrl字段值必须是项目中腾讯云存储桶中的文件地址'))
      }

      const zip = new JSZip();
      (async () => {
        const responses = await Promise.all(fileList.map(item => getTencentFile(item.tencentUrl.replace(item.tencentUrl.match(/.*\//)[0].slice(0, -1), ''))))
        responses.forEach((res, index) => {
          // 添加空文件夹
          const fileName = `${fileList[index].fileName}.zip`
          zip.file(fileName, res.data)
        })
        // 放置 Promise.all() 返回的 Promise 对象到外层
        return Promise.resolve()
      })().then(() => {
        // 生成并下载压缩包
        zip.generateAsync({ type: 'blob' }).then((content) => {
          const downloadUrl = window.URL.createObjectURL(content)
          const link = document.createElement('a')
          link.href = downloadUrl
          link.setAttribute('download', `案件材料.zip`)
          document.body.appendChild(link)
          link.click()
          // 释放 URL 对象
          URL.revokeObjectURL(link.href)
          resolve()
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取文件路径对应的 MIME 类型。
   * @param {string} filePath - 文件路径，包含文件名和后缀名。
   * @returns {string} - 对应的 MIME 类型，如果未找到匹配，则返回默认的 'application/octet-stream'。
   */
  getMimeType(filePath) {
    const mimeTypes = {
      txt: 'text/plain',
      html: 'text/html',
      css: 'text/css',
      js: 'application/javascript',
      xml: 'application/xml',
      json: 'application/json',
      jpeg: 'image/jpeg',
      jpg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      svg: 'image/svg+xml',
      bmp: 'image/bmp',
      mp3: 'audio/mpeg',
      wav: 'audio/wav',
      ogg: 'audio/ogg',
      mp4: 'video/mp4',
      zip: 'application/zip',
      webm: 'video/webm',
      pdf: 'application/pdf',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ppt: 'application/vnd.ms-powerpoint',
      pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      // 在这里可以继续添加其他文件后缀名和对应的 MIME 类型
    }
    const extension = filePath.split('.').pop()
    return mimeTypes[extension] || 'application/octet-stream'
  },

  // 转换千分数
  formateNumber(data, unit, precision) {
    const prec = precision || 2
    const unitStr = unit === '' ? unit : '￥'
    if (data === 0) { return unitStr + '0' }
    if (data === '' || !data) { return '' }
    const str = (typeof data === 'number' && !isNaN(data)) ? (data.toFixed(prec) + '') : data
    const arr = str.split('.')
    let formateStr = Number(arr[0]).toLocaleString()
    if (arr[1]) {
      formateStr += `.${arr[1]}`
    } else {
      formateStr += '.00'
    }
    return unitStr + formateStr
  },
  // 数字转千分位
  format_with_regex(val) {
    if (!val) return 0
    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (val + '').replace(reg, '$&,')
  },
  debounce(fn, delay) {
    // 记录上一次的延时器
    var timer = null
    var delay = delay || 200
    return function () {
      var args = arguments
      var that = this
      // 清除上一次延时器
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(that, args)
      }, delay)
    }
  },
  throttle(fn, delay) {
    var lastTime
    var timer
    var delay = delay || 200
    return function () {
      var args = arguments
      // 记录当前函数触发的时间
      var nowTime = Date.now()
      if (lastTime && nowTime - lastTime < delay) {
        clearTimeout(timer)
        timer = setTimeout(function () {
          // 记录上一次函数触发的时间
          lastTime = nowTime
          // 修正this指向问题
          fn.apply(this, args)
        }, delay)
      } else {
        lastTime = nowTime
        fn.apply(this, args)
      }
    }
  },
  // 根据传入的key和string 返回对应的数组对象
  strMapArr(obj) {
    const arrKey = []; const arr = []
    for (const key in obj) {
      arrKey.push(key)
    }
    if (!obj[arrKey[0]]) {
      return []
    }
    let json = {}
    const len = obj[arrKey[0]].split(',').length
    for (let i = 0; i < len; i++) {
      json = {}
      arrKey.forEach(item => {
        json[item] = obj[item].split(',')[i]
        if (typeof Number(json[item]) === 'number' && !isNaN(Number(json[item]))) {
          json[item] = Number(json[item])
        }
      })
      arr.push(json)
    }
    return arr
  },
  // 判断文件类型
  /** **
    * 返回值说明：
    * image是图片类型（可以使用viewer预览）
    * wps是文件类型（可以是用wps打开）
    * other是其他类型（直接使用a标签打开）
    ****/
  getFileType(mediaType) {
    if (mediaType.indexOf('image') != -1) {
      return 'image'
    } else if (mediaType.indexOf('.document') != -1 ||
      mediaType.indexOf('msword') != -1 ||
      mediaType.indexOf('.sheet') != -1 ||
      mediaType.indexOf('.ms-excel') != -1 ||
      mediaType.indexOf('pdf') != -1 ||
      mediaType.indexOf('text/plain') != -1 ||
      mediaType.indexOf('powerpoint') != -1 ||
      mediaType.indexOf('presentation') != -1) {
      return 'wps'
    } else {
      return 'other'
    }
  },
  /**
     *
     * @param {*} key 获取cookie中的内容
     * @returns
     */
  getCookie(key) {
    const arr = document.cookie.replace(/\s/g, '').split(';')
    for (var i = 0; i < arr.length; i++) {
      var tempArr = arr[i].split('=')
      if (tempArr[0] == key) {
        return decodeURIComponent(tempArr[1])
      }
    }
    return ''
  },
  getPublicUrl(key) {
    const url = '/base/cos/presigned-url/ap-guangzhou/' + config.uploadPrivateUrl + '?keys=' + key
    return new Promise(function (resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          const pubUrl = res.data[0]
          resolve(pubUrl)
        }
      })
    })
  },
  // 获取操作权限
  getPermission(value) {
    const options = store.state.permission && store.state.permission.options
    if (value && value instanceof Array && value.length > 0) {
      let permissionRoles = []
      let hasPermission = null

      if (value[0].indexOf('/') != -1) {
        permissionRoles = [permissionJson[value]]
      } else {
        permissionRoles = value
      }
      console.log('permissionRoles', permissionRoles)
      hasPermission = options.some(role => {
        return permissionRoles.includes(role)
      })
      if (permissionRoles.includes(false)) {
        hasPermission = !hasPermission
      }
      console.log('hasPermission', hasPermission)
      return hasPermission
    } else {
      return false
    }
  }
}
export default common



// WEBPACK FOOTER //
// ./src/libs/util.js